<form (validate)="save({ draft: false })" novalidate validation-es>
  <ms-consult-patient [patient]="patient" [edit]="isEdit" [(sticky)]="isSticky" (saveConsult)="save($event)"
    [saving]="saving">
  </ms-consult-patient>

  <article class="page-container page__consult" [attr.sticky]="isSticky ? 'sticky' : null">
    <p-tabView>
      <p-tabPanel [selected]="true">
        <ng-template pTemplate="header">
          {{screen.labels.actual}} {{today | date : 'dd-MM-yyyy' : '+0000'}}
        </ng-template>

        <ng-template pTemplate="content">
          <ms-odonto-wrapper name="odonto-wrapper__{{turnId}}" [(ngModel)]="odontoWrapper" [turn]="turnId"
            [patient]="turn.patient!" [isFirst]="isFirst" *ngIf="odontoWrapper">
          </ms-odonto-wrapper>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *ngFor="let oldTurn of oldTurns">
        <ng-template pTemplate="header">
          {{oldTurn.turnDate | date : 'dd-MM-yyyy' : '+0000'}}
        </ng-template>

        <ng-template pTemplate="content">
          <ms-consult-wrapper [turn]="oldTurn.id!" [readonly]="true"></ms-consult-wrapper>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </article>
</form>